<div class="align-distribute">
	<bb-icon-list
		[options]="options"
		[useOpacity]="true"
		[extraMargins]="[2]"
		[useImages]="true"
		[actionOnly]="true"
		[showMoLabels]="true"
		(selected)="onOptionSelected($event)"
	></bb-icon-list>
</div>
